export const constants = {
    supportSMS: '(317) 210-0644',
    supportSMSBody: '[Primary Record Support]\n',
    supportEmail: 'support@primaryrecord.com',
    supportEmailSubject: 'Support Request',
    supportEmailBody: 'How can we help you?\n',
    supportWebsite: 'https://www.primaryrecord.com/contact/',
    primaryRecordYoutube: 'https://www.youtube.com/@primaryrecord',
};

export const AVATAR_UPLOAD_QUALITY = 0.1;
export const CARD_UPLOAD_QUALITY = 0.5;
export const RESOURCE_IMAGE_UPLOAD_QUALITY = 0.5;
export const CARD_ASPECT_RATIO = [3.375, 2.125] as [number, number];

export const cannyAppID = '63dd45140b697344f98bc6a2';
export const feedbackAndRoadmapUrl = 'https://primary-record.canny.io/feedback/';
export const primaryRecordHome = 'https://www.primaryrecord.com/';
export const aboutUrl = 'https://www.primaryrecord.com/about/';
export const careersUrl = 'https://www.primaryrecord.com/careers/';
export const contactUrl = 'https://www.primaryrecord.com/contact/';
export const faqUrl = 'https://support.primaryrecord.com/faq';
export const privacyPolicyUrl = 'https://www.primaryrecord.com/privacy-policy/';
export const termsOfServiceUrl = 'https://www.primaryrecord.com/terms-of-service/';
export const supportEmail = 'support@primaryrecord.com';
export const scheduleSupportChatUrl =
    'https://meetings.hubspot.com/jean-ross/meet-primary-record?__hstc=18061094.acea3b8be3d79e106e06929d2b4d63dd.1720192271694.1726514400500.1726522937384.114&__hssc=18061094.5.1726522937384&__hsfp=1400577961&uuid=c82fea81-08d4-4470-b7f2-8c996f152889';
export const guidanceHubspotUrl =
    'https://support.primaryrecord.com/meetings/jean-ross/nurse-navigator-personal-on-boarding-session/';
export const scheduleACallUrl =
    'https://meetings.hubspot.com/jean-ross/meet-primary-record?__hstc=18061094.3649b3bdb8e7df48bac0c1904fff8e5d.1707905375545.1726583468310.1726592501090.13&__hssc=18061094.2.1726592501090&__hsfp=1400577961';
export const recordingAVisitLearnMore =
    'https://support.primaryrecord.com/what-legal-consent-is-needed-to-record-my-doctor-at-a-visit';
export const recordingDisabledHelpUrl = 'https://support.primaryrecord.com/unreliable-note-saving-on-ios-pro-app';
export const helpCenterUrl = 'https://www.primaryrecord.com/help-center/';
export const salesEmail = 'sales@primaryrecord.com';
export const statusPageUrl = 'https://status.primaryrecord.app/';
export const carinCodeOfConductUrl =
    'https://www.primaryrecord.com/wp-content/uploads/2024/09/2020_CARIN_Code_of_Conduct_May-2020_v2.pdf';
export const blogUrl = 'https://www.primaryrecord.com/blog/';
export const trustCenterUrl = 'https://trust.primaryrecord.com/';
// Shared-report viewer locations come from DB-IP's CC-BY-4.0 City Lite database, which requires a visible credit.
export const dbIpAttributionUrl = 'https://db-ip.com';
export const primaryRecordFacebookUrl = 'https://www.facebook.com/primaryrecord';
export const primaryRecordLinkedInUrl = 'https://www.linkedin.com/company/primary-record/';
export const primaryRecordInstagramUrl = 'https://www.instagram.com/primaryrecord/';
export const subscribeToTheNewsletterUrl = 'https://www.primaryrecord.com/newsletter-signup/';
export const advancedDirectiveFormsUrl = 'https://www.primaryrecord.com/advanced-directives-forms/';
export const appStoreAppUrl = 'https://apps.apple.com/us/app/primary-record/id6468519519';
export const playStoreAppUrl =
    'https://play.google.com/store/apps/details?id=com.primaryrecord.primaryrecord.android&hl=en_US';

export const MOBILE_WIDTH_CUTOFF = 768;
